export class FetchToken {
  public static get(): string {
    if (localStorage.getItem('actionCenterToken')) {
      return localStorage.getItem('actionCenterToken');
    } else {
      return localStorage.getItem('token');
    }
  }
}
